export const KHAN_GRAPHQL_URL =
  'https://www.khanacademy.org/api/internal/graphql'

export const SAFELIST_URL =
  'https://cdn.jsdelivr.net/gh/bhavjitChauhan/khan-api@safelist'

export const PROXY_DOMAIN = 'khan-proxy.bhavjit.com'

// Hopefully this doesn't cause any consequences...
export const FKEY = `bhavjitchauhan/khan-api_${Date.now()}`

export const PLACEHOLDER_PROGRAM_ID = 4669512406581248
